export default "__VITE_ASSET__DOSY2MQx__"